<div class="page-sheet"
    [style.visibility]="loadingPage$$() ? 'hidden' : 'visible'"
    [@routeAnimations]="loadingPage$$() ? 'hidden' : 'visible'"
>
    <ng-container *ngTemplateOutlet="template_page" />
    <!-- Page-lock-overlay (langlopende actie, bv. hoofdfoto-upload): blokkeert klikken op de
         content en toont een spinner; de footer-progressbar toont de voortgang. -->
    @if (locked$$()) {
        <div class="page-lock-overlay"><div class="page-lock-spinner"></div></div>
    }
</div>
<app-footer />

<ng-template #template_footerLeft>
    <app-button-navigation footerLeftBlok
        (btnClick)="emit_onClickReturn();"
        [loadKey]="loadKey.screenLock"
        [lockOnLoad]="true"
        [tooltip]="displayName$$()"
        [tooltipPosition]="'above'"
    >
        <app-icon name="arrow-left"></app-icon>
    </app-button-navigation>
</ng-template>
